import { Navigate, useLocation } from 'react-router-dom';

/**
 * Sprint 11 (F9): the old Team report URL becomes Reports → Team with every other parameter kept. Not
 * wrapped in AdminRoute: anyone may follow an old link (the Reports page decides what they can see).
 */
export function AdminReportRedirect(): JSX.Element {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('view', 'team');
  return <Navigate replace to={`/reports?${params.toString()}`} />;
}
